import { Component, OnInit, ContentChild, TemplateRef, Input } from '@angular/core';

@Component({
  selector: 'app-accordion-panel',
  templateUrl: './accordion-panel.component.html',
  styleUrls: ['./accordion-panel.component.scss'],
})
export class AccordionPanelComponent implements OnInit {

  @Input() color: string;
  @Input() panelData: any;
  @Input() public collapsed: boolean;
  @Input() public headerIndex:number;
  @Input() public currentIndex:number;
  @ContentChild('panelHeader', {static: false}) panelHeader: TemplateRef<any>;
  @ContentChild('panelBody', {static: false}) panelBody: TemplateRef<any>;

  constructor() {
    // If an initial collapse status wasn't specified then default to collapsed
    if (this.collapsed === undefined)
    {
      this.collapsed = true;
    }
  }

  ngOnInit() {}

}
